import React from "react";
import Header from "../components/Header";
import IntergrationsCom from "../components/Intergrations";

const Intergrations = ({ LeftNavRef }) => {
  return (
    <div className="w-full px-4 md:px-10 pb-10">
      <Header LeftNavRef={LeftNavRef} />
      <IntergrationsCom />
    </div>
  );
};

export default Intergrations;
